import Button from '@/components/shared/Button/Button';

interface LockedBannerProps {
  canDuplicate: boolean;
  isDuplicating: boolean;
  onDuplicate: () => void;
}

const LockedBanner = ({ canDuplicate, isDuplicating, onDuplicate }: LockedBannerProps) => (
  <div className="flex items-center justify-between gap-4 rounded-2xl bg-primary-10 px-5 py-3">
    <p className="text-sm text-neutral-80">
      <b>Structure is locked while the journey is online.</b> Users’ progress is tied to its miles,
      steps and blocks, so they can’t be added, removed or moved. Titles, texts and JSON can still
      be edited. To restructure, duplicate the journey and publish the copy.
    </p>
    <span
      title={
        canDuplicate
          ? undefined
          : 'Save your changes first: the copy is made from the saved journey'
      }
    >
      <Button
        label={isDuplicating ? 'Duplicating...' : 'Duplicate'}
        variant="transparent"
        size="s"
        className="!w-32 bg-white-100"
        disabled={!canDuplicate || isDuplicating}
        prefixIcon={<img src="/icons/copy.svg" alt="" />}
        onClick={onDuplicate}
      />
    </span>
  </div>
);

export default LockedBanner;
